<div class="row page-header" [hidden]="embedded">
    <div class="col-12">
        <h1>Upcoming Prequalification <small>View and manage the upcoming bid prequalifications</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="grid"></action-toolbar-count>
                        <action-toolbar-buttons
                            [grid]="grid"
                            [canEdit]="canEdit"
                            [showAdd]="true"
                            [showEdit]="true"
                            [showDelete]="true"
                        ></action-toolbar-buttons>
                        <button type="button" class="btn btn-sm btn-secondary" (click)="complete()" [disabled]="!grid.hasItemSelected">
                            <fa-icon [icon]="faCheck"></fa-icon> Complete
                        </button>
                        <action-toolbar-search name="search" [(ngModel)]="grid.filter"></action-toolbar-search>
                        <grid-export [grid]="mainGrid" [name]="'Bid Prequalification'"></grid-export>
                        <button
                            type="button"
                            class="btn btn-sm btn-secondary"
                            style="margin-left: auto"
                            (click)="showAll = !showAll; filterItems()"
                        >
                            {{ showAll ? 'Hide Complete' : 'Show Complete' }}
                        </button>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="mainGrid"
                        #mainGrid
                        appAutoSize
                        (initialized)="grid.initialize(mainGrid)"
                        (destroy)="grid.destroy()"
                        (beginningEdit)="cellBeginningEdit(mainGrid, $event)"
                        (cellEditEnded)="cellEditEnded(mainGrid, $event)"
                        (pasting)="pasting(mainGrid, $event)"
                        (pasted)="pasted(mainGrid, $event)"
                        [itemsSource]="grid.view"
                        [keyActionTab]="'CycleEditable'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'name'" [width]="300"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Owner'"
                            [binding]="'ownerId'"
                            [width]="180"
                            [dataMap]="ownersMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Bid Type'"
                            [binding]="'bidTypeId'"
                            [width]="200"
                            [dataMap]="jobTypeMap"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Pre-Proposal Meeting'"
                            [binding]="'preProposalMeetingDate'"
                            [width]="225"
                            [format]="'g'"
                            [editor]="inputDateTime"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Mandatory'" [binding]="'mandatory'" [width]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Due Date'"
                            [binding]="'dueDate'"
                            [width]="225"
                            [format]="'g'"
                            [editor]="inputDateTime"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Notification Date'"
                            [binding]="'notificationDate'"
                            [width]="140"
                            [editor]="inputDate"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Docs Available Date'"
                            [binding]="'docsAvailableDate'"
                            [width]="140"
                            [editor]="inputDate"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Completion Date'"
                            [binding]="'completionDate'"
                            [width]="140"
                            [editor]="inputDate"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Prequal Meeting'" [binding]="'prequalMeeting'" [width]="100"></wj-flex-grid-column>-->
                        <wj-flex-grid-column
                            [header]="'Engineer Estimate'"
                            [binding]="'bidRangeId'"
                            [width]="155"
                            [dataMap]="rangeMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <!--<wj-flex-grid-column [header]="'Scheduler Name'" [binding]="'schedulerHrRef'" [width]="150" [dataMap]="allUserMap" [isRequired]="false"></wj-flex-grid-column>-->
                        <wj-flex-grid-column
                            [header]="'PM Name'"
                            [binding]="'pmHrRef'"
                            [width]="150"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Super Name'"
                            [binding]="'superHrRef'"
                            [width]="150"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Estimator Name'"
                            [binding]="'estimatorHrRef'"
                            [width]="150"
                            [dataMap]="allUserMap"
                            [isRequired]="false"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="'*'" [minWidth]="250"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <wj-input-date #inputDate [isRequired]="false"></wj-input-date>
                    <wj-input-date-time #inputDateTime [timeStep]="30" [isRequired]="false"></wj-input-date-time>
                </div>
            </div>
        </div>
    </div>
</div>
